import React from 'react';

import { NexoyaMeasurement } from '../types/types';

import useKpiSelectionController from '../controllers/KpiSelectionController';

interface KpisSelectionContextValue {
  addMap: Map<string, NexoyaMeasurement>;
  removeMap: Map<string, NexoyaMeasurement>;
  selected: NexoyaMeasurement[];
  initialSelected: NexoyaMeasurement[];
  compareFn: (a: NexoyaMeasurement, b: NexoyaMeasurement) => boolean;
  keyFn: (a: NexoyaMeasurement) => string;
  add: (adding: NexoyaMeasurement | NexoyaMeasurement[]) => void;
  remove: (removing: NexoyaMeasurement | NexoyaMeasurement[]) => void;
  reset: () => void;
  setInitial: (data: NexoyaMeasurement[]) => void;
  touched: boolean;
}

const KpisSelectionContext = React.createContext<KpisSelectionContextValue | null>(null);

function KpisSelectionProvider(props: any) {
  const value = useKpiSelectionController();
  return <KpisSelectionContext.Provider value={value} {...props} />;
}

function withKpisSelectionProvider(Component: any) {
  return (props: any) => (
    <KpisSelectionProvider>
      <Component {...props} />
    </KpisSelectionProvider>
  );
}

function useKpisSelection() {
  const context = React.useContext(KpisSelectionContext);

  if (context === undefined) {
    throw new Error('useKpisSelection: must be used within <KpisSelectionProvider />');
  }

  return context;
}

export { KpisSelectionProvider, withKpisSelectionProvider, useKpisSelection };
